import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  valor: Yup.string().required('O campo valor é obrigatório'),
});

export default validationSchema;
